import { useState } from "react";
import BridgeHistorySections from "./history/BridgeHistorySections";
import VideoHistorySections from "./history/VideoHistorySections";

type Source = "bridge" | "video";

/**
 * 이력·통계 탭 본문. 브릿지(DB헬스)/영상분석 두 소스를 서브탭으로 분리.
 *  - 브릿지: 주차장(lot) 단위 (층 세분화는 추후)
 *  - 영상분석: 주차장 > 구역(zone)
 */
export default function HistoryTab() {
  const [source, setSource] = useState<Source>("bridge");

  return (
    <div>
      <div className="mb-4 inline-flex rounded-lg border border-surface-border bg-surface p-0.5 dark:border-surface-darkBorder dark:bg-surface-darkSubtle">
        {([
          ["bridge", "브릿지"],
          ["video", "영상분석"],
        ] as const).map(([key, label]) => (
          <button
            key={key}
            type="button"
            onClick={() => setSource(key)}
            className={
              "min-h-[2.75rem] rounded-md px-4 py-2 text-sm font-medium transition-colors sm:min-h-0 sm:py-1.5 " +
              (source === key
                ? "bg-slate-800 text-white dark:bg-slate-100 dark:text-slate-900"
                : "text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200")
            }
          >
            {label}
          </button>
        ))}
      </div>

      {source === "bridge" ? <BridgeHistorySections /> : <VideoHistorySections />}
    </div>
  );
}
